import React, { useState } from 'react';
import { Lock, Unlock, ShieldAlert } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

export default function AdminGate({ admin }) {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');

  if (admin.isAdmin) {
    return (
      <button
        onClick={admin.logout}
        className="inline-flex items-center gap-1.5 rounded-md bg-emerald-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-emerald-700"
        title="You can edit. Click to lock."
      >
        <Unlock className="h-3.5 w-3.5" /> Admin
      </button>
    );
  }

  if (!admin.promptOpen) {
    return (
      <button
        onClick={() => admin.setPromptOpen(true)}
        className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50"
        title="View only. Click to unlock editing."
      >
        <Lock className="h-3.5 w-3.5" /> View only
      </button>
    );
  }

  const submit = (e) => {
    e.preventDefault();
    if (!admin.login(pw)) setErr('Incorrect password.');
    else setErr('');
    setPw('');
  };

  return (
    <form onSubmit={submit} className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-2">
        <Input
          type="password"
          value={pw}
          onChange={(e) => { setPw(e.target.value); setErr(''); }}
          placeholder="Admin password"
          autoFocus
          className="h-8 w-40 text-sm"
        />
        <Button type="submit" size="sm">Unlock</Button>
        <Button type="button" size="sm" variant="ghost" onClick={() => { admin.setPromptOpen(false); setErr(''); }}>
          Cancel
        </Button>
      </div>
      {err && <span className="text-xs text-red-600">{err}</span>}
      {!admin.configured && (
        <span className="flex items-center gap-1 text-xs text-amber-700">
          <ShieldAlert className="h-3 w-3" />
          No password set - add REACT_APP_ADMIN_PASSWORD to .env
        </span>
      )}
    </form>
  );
}
